import { render, staticRenderFns } from "./EmpresaContatos.vue?vue&type=template&id=3cb7db70&scoped=true"
import script from "./EmpresaContatos.vue?vue&type=script&lang=js"
export * from "./EmpresaContatos.vue?vue&type=script&lang=js"
import style0 from "./EmpresaContatos.vue?vue&type=style&index=0&id=3cb7db70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7db70",
  null
  
)

export default component.exports